<script setup lang="ts">
import { useNavigation } from '../../composables/useNavigation/useNavigation';
import { useRouter } from 'vue-router';
const { currentRoute } = useRouter();

const { mainLinks } = useNavigation();
</script>
<template>
  <scale-telekom-mobile-menu slot="mobile-main-nav">
    <router-link
      v-for="link of mainLinks"
      :key="link.name"
      :to="{ name: link.name, params: { lang: currentRoute.params['lang'] || 'en' } }"
      custom
      v-slot="{ isActive, href, navigate }"
    >
      <scale-telekom-mobile-menu-item
        :active="isActive"
        :aria-label="$t(link.titleKey)"
      >
        <a
          :href="href"
          :title="$t(link.titleKey)"
          :aria-current="isActive"
          @click="navigate"
          >{{ $t(link.titleKey) }}</a
        >
      </scale-telekom-mobile-menu-item>
    </router-link>
  </scale-telekom-mobile-menu>
</template>
